import { db } from "~/db/db";
import { getEstruturaSincronizacao } from "~services/GlobalServices";
import { useMemo, useCallback } from 'react';

const useSyncWorker = ({ table, setLoading, setFinished, enabled }) => {
  const workerAdd = useMemo(() => { if (enabled) return new Worker(new URL("~/db/syncWorkerAdd.js", import.meta.url), { type: "module" }) }, [enabled]);
  const workerRemove = useMemo(() => { if (enabled) return new Worker(new URL("~/db/syncWorkerRemove.js", import.meta.url), { type: "module" }) }, [enabled]);

  const updateSincronizacao = useCallback((quantidade, date) => {
    const estrutura = getEstruturaSincronizacao(table);
    if (estrutura) {
      const dados = {
        id: estrutura.id,
        table: table,
        nome: estrutura.nome,
        data: date,
        quantidade: quantidade,
      };
      db.sincronizacao.put(dados);
    } else {
      console.log("Não foi criada a estrutura de sincronização para a tabela:", table);
    }
  }, [table]);

  const handleLoadingState = useCallback(async (clearCache, update, quantidade, data, options = {}) => {
    if (update) {
      const total = options.quantidadeTotal ? await db.table(table).count() : quantidade;
      updateSincronizacao(total, options.dataSincronizacao ?? new Date());
    }
    if (clearCache && typeof clearCache === 'function') clearCache();
    if (setLoading && typeof setLoading === 'function') setLoading(false);
    if (setFinished && typeof setFinished === 'function') setFinished(true);
  }, [table, updateSincronizacao, setLoading, setFinished]);

  const save = useCallback((data, clearCache = null, update = true, clear = false, options = {}) => {
    if (data.length === 0) {
      handleLoadingState(clearCache, update, 0, data, options);
      workerAdd.terminate();
    }
    if (data.length > 0) {
      workerAdd.postMessage({ table, data, clear });

      workerAdd.onmessage = (event) => {
        const quantidade = data.length;
        handleLoadingState(clearCache, update, quantidade, data, options);

        data = [];
        workerAdd.terminate();
      };
    }
  }, [table, workerAdd, handleLoadingState]);

  const removeIds = useCallback((data, clear) => {
    if (data.length === 0 || clear) {
      console.log(table, "terminou");
      workerRemove.terminate();
    }
    if (data.length > 0) {
      workerRemove.postMessage({ table, data });
      workerRemove.onmessage = (event) => {
        data = [];
        console.log(table, "terminou");
        workerRemove.terminate();
      };
    }
  }, [table, workerRemove]);

  return { save, removeIds };
};

export default useSyncWorker;